import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Scrollbar } from "swiper/modules";
import SimpleBar from "simplebar";
import _ from "lodash";
import axios from "axios";
import { mq } from "./modules/mq";
import { showAllAccordion, showAccordion } from "./modules/utils";

const { template, templateSettings } = _;
templateSettings.interpolate = /\{\{=([\s\S]+?)\}\}/g;
templateSettings.evaluate = /\{\{([\s\S]+?)\}\}/g;

const topFirstSlider = () => {
  const swiper = new Swiper(".top-first-slider", {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: {
      delay: 3000,
    },
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    centeredSlides: true,
    spaceBetween: 100,
  });
};

const topNewsSlider = () => {
  const swiper = new Swiper(".top-news-slider", {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      },
    },
    loop: true,
    spaceBetween: 20,
    // Navigation arrows
    navigation: {
      nextEl: ".news-swiper-button-next",
      prevEl: ".news-swiper-button-prev",
    },
  });

};

const topInstractorSlider = () => {
  const swiper = new Swiper(".top-instractor-slider", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: "auto",
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
    loop: true,
    spaceBetween: 30,
    // Navigation arrows
    navigation: {
      nextEl: ".instractor-swiper-button-next",
      prevEl: ".instractor-swiper-button-prev",
    },
    speed: 1000,
    centeredSlides: true,
    autoplay: {
      delay: 3000,
    },
  });
};

const instractorModal = () => {
  const jsModalWrap = document.getElementById("jsModalWrap");
  const modals = document.querySelectorAll(".js-modal");
  const openTriggers = document.querySelectorAll(".js-open-modal");
  const closeTriggers = document.querySelectorAll(".js-close-modal");
  const closeUpperBtns = document.querySelectorAll(".js-close");

  const jsModalOuter = document.querySelectorAll(".js-modal-outer");
  const body = document.getElementsByTagName("body")[0];
  let activeClickedSlide = "";

  openTriggers.forEach((openTrigger, index) => {
    let modal = modals[index];
    openTrigger.addEventListener("click", () => {
      activeClickedSlide = `${openTrigger.id}-modal`;
      sessionStorage.setItem("activeClickedSlide", activeClickedSlide);
      // modalsのIDに ${openTrigger.id}-modal が存在する場合
      // そのIDのmodalを表示する
      // ない場合は、最初のmodalを表示する
      if (document.getElementById(activeClickedSlide)) {
        modal = document.getElementById(activeClickedSlide);
        modal.classList.add("is-open");
      }
      jsModalWrap.classList.add("is-open");
      body.classList.add("modal-open");
    });
  });

  modals.forEach((modal, index) => {
    modal.addEventListener("click", (e) => {
      console.log("modals");
      e.target.classList.remove("is-open");
      jsModalWrap.classList.remove("is-open");
      body.classList.remove("modal-open");
    });
  });
  jsModalOuter.forEach((modalOuter, index) => {
    modalOuter.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });
  closeTriggers.forEach((closeTrigger, index) => {
    closeTrigger.addEventListener("click", () => {
      const modal = document.getElementById(sessionStorage.getItem("activeClickedSlide"));
      console.log("closeTriggers");
      modal.classList.remove("is-open");
      jsModalWrap.classList.remove("is-open");
      body.classList.remove("modal-open");
    });
  });

  closeUpperBtns.forEach((closeTrigger, index) => {
    closeTrigger.addEventListener("click", () => {
      const modal = document.getElementById(sessionStorage.getItem("activeClickedSlide"));
      console.log("closeUpperBtns");
      modal.classList.remove("is-open");
      jsModalWrap.classList.remove("is-open");
      body.classList.remove("modal-open");
    });
  });
};

const youtubeModal = () => {
  const jsYoutubeModalWrap = document.getElementById("jsYoutubeModalWrap");
  const jsYoutubeModal = document.getElementById("jsYoutubeModal");
  const body = document.getElementsByTagName("body")[0];
  const jsYoutubeModalClose = document.getElementById("jsYoutubeModalClose");
  // const kidscheerVideo = document.getElementById("kidscheerVideo");

  jsYoutubeModal.addEventListener("click", () => {
    jsYoutubeModalWrap.classList.add("is-open");
    body.classList.add("modal-open");
    // kidscheerVideo.play();
  });

  jsYoutubeModalClose.addEventListener("click", () => {
    jsYoutubeModalWrap.classList.remove("is-open");
    body.classList.remove("modal-open");
    // kidscheerVideo.pause();
  });
};

// Menu UI Functions
const menuToggleFunc = () => {
  const mTrigger = document.getElementById("menu-trigger");
  const jsMainMenuChildren = document.querySelectorAll(".js-main-menu");
  const { body } = document;

  jsMainMenuChildren.forEach((child) => {
    child.addEventListener("click", () => {
      if (body.classList.contains("menu-show")) {
        body.classList.remove("menu-show");
      }
    });
  });

  mTrigger.addEventListener("click", () => {
    if (body.classList.contains("menu-show")) {
      body.classList.remove("menu-show");
    } else {
      body.classList.add("menu-show");
    }
  });

};

// TOPICS読み込み
const includeFnc = (FILENAME, idName) => {
  const body = document.getElementsByTagName("body")[0];
  const target = document.getElementById(idName);
  if (!target) return;

  let URL = `/company/csr/academy/inc/${FILENAME}.html`;

  axios({
    method: "get",
    url: URL,
    responseType: "document",
  }).then((res) => {
    const isRoot = body.dataset.tree === "root";
    const isSecond = body.dataset.tree === "second";

    const compile = template(res.data.body.children[0].innerHTML);
    // let PATH = `/ex/lastspurt/`; // 本番用※本番に反映する際はこちらを活性表示
    let PATH = `/company/csr/academy/`; // ローカル確認用※本番に反映する際はコメントアウト

    if (isRoot) PATH = `./`;
    if (isSecond) PATH = `../`;

    let IMGPATH = `/company/csr/academy/assets/img/`;

    if (isRoot) IMGPATH = `./`;
    if (isSecond) IMGPATH = `../`;

    const html = compile({
      path: PATH,
      imgpath: IMGPATH,
    });
    target.innerHTML = html;
    if (FILENAME === "header") {
      if (mq("sp")) {
        menuToggleFunc();
      }
    }
    if (FILENAME === "report") {
      topNewsSlider();
    }
    if (FILENAME === "topslider") {
      topFirstSlider();
    }
  });
};

// フッター部分で体験ボタン非表示
const hideExperienceBtn = () => {
  let isBtnHide = false;
  const fixedLinkBtn = document.getElementById("fixedLinkBtn");
  const ajustNum = 200;
  window.onscroll = (ev) => {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - ajustNum) {
      if (!isBtnHide) {
        fixedLinkBtn.classList.add("hide");
        isBtnHide = true;
      }
    } else {
      fixedLinkBtn.classList.remove("hide");
      isBtnHide = false;
    }
  };
};

// スクロールイベント
window.addEventListener("scroll", () => {});

// ページ表示時イベント
document.addEventListener("DOMContentLoaded", () => {
  // TOPページのみ
  if (document.getElementById("topPage")) {
    topInstractorSlider();
    showAccordion(".js-dt");
    showAccordion(".js-schedule-title");
    hideExperienceBtn();
    youtubeModal();
    includeFnc("information", "informationWrap");
    includeFnc("report", "reportWrap");
    includeFnc("topslider", "topsliderWrap");
  }

  // 汎用
  includeFnc("header", "headerWrap");
});

// ページ読み込み完了時イベント
window.addEventListener("load", () => {
  // TOPページのみ
  if (document.getElementById("topPage")) {
    instractorModal();
  }
});

// ページリサイズ時イベント
window.addEventListener("resize", () => {});
